module.exports = __webpack_public_path__ + "static/media/3.20497d6a.svg";